import {EvergentPaymentProvider} from "./Evergent/EvergentPaymentProvider.tsx";

export interface PaymentProvider {
    paymentForm: string;
    PaymentProviderComponent: React.ReactNode;
    RegistrationFlow: React.FC;
    MigrationFlow: React.FC;
    OnUnsubscribeHandle: (navigate: Function, subscription: object)=>void;
    UnsubscribeComponent: React.ReactNode;
}

export default function usePaymentProvider(): PaymentProvider {
    return new EvergentPaymentProvider();
}
